import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { apiRouter } from '$domain/model/apiRouter'

export const caretakerAcceptService = async (requestId: string) => {
  try {
    await familiadosApiClient.post(apiRouter.caretakerAcceptServicePath(requestId))
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const caretakerRejectService = async (serviceId: string) => {
  try {
    await familiadosApiClient.post(apiRouter.caretakerRejectServicePath(serviceId))
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakerServiceResponse/caretakerServiceResponse.manager.ts